import React from 'react';

import { readCMSValue } from 'modules/shared-cms/utils';

import { Carousel } from 'modules/shared-ui-advanced/components';
import { LargeBlocList } from 'modules/shared-cms/components';
import { TitleBloc, ModelBloc, LabelTitle } from 'modules/shared-cms-advanced/components';

import { WeddingLandingProps } from './wedding-landing-type';

import enhancer from './wedding-landing-enhancer';

import styles from './wedding-landing-page.module.css';

const weddingLandingPage: React.FC<WeddingLandingProps> = React.memo((props: WeddingLandingProps) => {
    const {
        carouselItems,
        labelTitle1,
        currentlyLabel,
        moreLabel,
        imageBlocList,
        carouselItems2,
        labelTitleFontColor,
        labelTitleFontSize,
    } = props;
    const {
        uwCarouselItems = readCMSValue(carouselItems),
        uwCarouselItems2 = readCMSValue(carouselItems2),
        uwImageBlocList = readCMSValue(imageBlocList),
    } = {};

    return (
        <React.Fragment>
            <div className="full-height">
                <div className={styles.title}>
                    <LabelTitle title={labelTitle1} textColor={labelTitleFontColor} fontSize={labelTitleFontSize} />
                </div>
                <div className={styles.carouselWrapper}>
                    <Carousel cards={1} auto>
                        {uwCarouselItems &&
                            uwCarouselItems.slice().map(item => {
                                return (
                                    <React.Fragment key={Math.random()}>
                                        <TitleBloc {...item} />
                                    </React.Fragment>
                                );
                            })}
                    </Carousel>
                </div>
                <div className={styles.title}>
                    <LabelTitle title={currentlyLabel} textColor={labelTitleFontColor} fontSize={labelTitleFontSize} />
                </div>
                <div>
                    {uwImageBlocList && uwImageBlocList.length > 0 && <LargeBlocList imageBlocList={uwImageBlocList} />}
                </div>
                <div className={styles.title}>
                    <LabelTitle title={moreLabel} textColor={labelTitleFontColor} fontSize={labelTitleFontSize} />
                </div>
                <Carousel cards={4} auto>
                    {uwCarouselItems2 &&
                        uwCarouselItems2.slice().map(item => {
                            return (
                                <React.Fragment key={Math.random()}>
                                    <ModelBloc {...item} />
                                </React.Fragment>
                            );
                        })}
                </Carousel>
            </div>
        </React.Fragment>
    );
});

export const WeddingLandingPage = enhancer(weddingLandingPage);
